import { BasePreviewViewStore, BaasicDropdownStore } from 'core/stores';
import { applicationContext } from 'core/utils';
import { FacilityService } from 'application/facility/services';
import { FacilityOrderTemplateService } from "application/facility-order/services";
import { MissingDocumentService } from 'application/missing-document/services';
import { LookupService } from "common/services";
import { FacilityMissingDocsEditViewStore } from "application/facility-missing-docs/stores";
import { DocumentationRequestService } from "application/documentation-request/services";
import { action, observable } from 'mobx';
import _ from 'lodash';
import moment from 'moment';

@applicationContext
class FacilityMissingDocsPreviewViewStore extends BasePreviewViewStore {
    @observable accessor facilityOrderTemplateStores = false;
    @observable accessor showOnlyPastTemplates = false;
    constructor(rootStore) {
        const id = rootStore.routerStore.routerState.params.id;
        const service = new FacilityService(rootStore.application.baasic.apiClient);
        super(rootStore, {
            name: 'facility-missing-docs-preview',
            autoInit: false,
            id: id,
            actions: () => {
                return {
                    get: async (id) => {
                        const response = await service.get(id);
                        return response.data;
                    }
                }
            }
        });

        this.showOnlyPastTemplates = `${rootStore.routerStore.routerState.params.showOnlyPastTemplates}` == 'true';

        this.facilityStore = new BaasicDropdownStore({
            filterable: true, initFetch: false,
        }, {
            fetchFunc: async (term) => {
                const response = await service.find({ searchQuery: term, rpp: 50, fields: "id,name" });
                return response.data.item;
            },
            onChange: (selected) => {
                var facility = this.facilityStore.items.find(x => x.id === selected);
                if (facility) {
                    window.location.replace(this.rootStore.routerStore.findRoute("master.app.main.facility-missing-docs.preview").pattern.replace(":id", facility.id).replace(":showOnlyPastTemplates", false));
                }
            }
        });

        this.facilityOrderTemplateService = new FacilityOrderTemplateService(rootStore.application.baasic.apiClient);

        this.fetch([
            this.initialize()
        ]);
    }

    @action
    async initialize() {
        await this.getMissingDocuments();
        await this.fetchFacilityOrderTemplates();
        await this.getResource(this.id);
        this.facilityStore.setValue(this.item);
        this.facilityStore.filterAsync();
    }
    @action.bound
    async getMissingDocuments() {
        const missingDocumentService = new MissingDocumentService(this.rootStore.application.baasic.apiClient);
        this.missingDocuments = (await missingDocumentService.find({ rpp: 100, isActive: true, sort: 'name|asc' })).data.item;

        const lookupService = new LookupService(this.rootStore.application.baasic.apiClient);
        this.lookups = await lookupService.getLookups("ImportAction,SpecialtyType");
    }

    @action.bound
    async fetchFacilityOrderTemplates() {
        const latestFacilityOrder = await this.facilityOrderTemplateService.find({ facilityId: this.id, pageSize: 1, fields: "facilityOrderId", orderBy: "FacilityOrder.DateOfService", orderDirection: "asc" });
        this.latestFacilityOrderId = latestFacilityOrder.data.item && latestFacilityOrder.data.item[0] && latestFacilityOrder.data.item[0].facilityOrderId;
        let params = {
            pageSize: 10000,
            facilityId: this.id,
            dosDateFrom: moment(new Date()).add(-1, 'y').format('YYYY-MM-DD'),
            embed: 'Patient,SubCategory,SubCategory.ItemCategory,FacilityOrder,ClinicalStatus,FacilityOrderTemplateMissingDocuments,FacilityOrderTemplateItems',
            orderBy: "FacilityOrder.DateOfService",
            orderDirection: "asc",
        }

        let facilityOrderTemplates = [];
        if (this.latestFacilityOrderId) {
            const response = (await this.facilityOrderTemplateService.find({ ...params, facilityOrderId: this.latestFacilityOrderId, isDischarged: false })).data.item;
            facilityOrderTemplates = response.filter(x => (!x.facilityOrder.isEnteralWeek || x.subCategory.itemCategory.abrv === 'enteral') && ((x.clinicalStatus && x.clinicalStatus.name === "Does Not Meet Insurance Criteria") || (x.facilityOrderTemplateMissingDocuments && x.facilityOrderTemplateMissingDocuments.some(x => x.id))));
        }

        let includedFacilityOrderTemplates = (await this.facilityOrderTemplateService.find({ ...params, includeInDocReqEmail: true })).data.item;
        includedFacilityOrderTemplates = includedFacilityOrderTemplates.filter(x => !x.facilityOrder.isEnteralWeek || x.subCategory.itemCategory.abrv === 'enteral');

        _.each(includedFacilityOrderTemplates, (facilityOrderTemplate) => {
            facilityOrderTemplates.push(facilityOrderTemplate);
        });

        facilityOrderTemplates = _.orderBy(facilityOrderTemplates, ['patient.lastName', 'patient.firstName', 'templateId'], ['asc', 'asc', 'asc']);

        this.facilityOrderTemplateStores = facilityOrderTemplates.map(item =>
            new FacilityMissingDocsEditViewStore(this.rootStore, { item: item, missingDocuments: this.missingDocuments, isCurrent: this.latestFacilityOrderId == item.facilityOrderId, lookups: this.lookups })
        );
    }

    @action.bound
    async documentationRequestCreate() {
        if (!this.latestFacilityOrderId) {
            this.rootStore.notificationStore.error('Documentation request email cannot be created because there is no Facility Order for this Facility.');
        }
        else {
            const documentationRequestService = new DocumentationRequestService(this.rootStore.application.baasic.apiClient);
            var result = await documentationRequestService.checkMissingDocuments({ facilityOrderId: this.latestFacilityOrderId });
            if (result.data) {
                window.open(`${this.rootStore.routerStore
                    .findRoute('master.app.main.facility-order.documentation-request-new-flow.edit-email')
                    .pattern.replace(":facilityOrderId", this.latestFacilityOrderId)}
                    `);
            }
            else {
                this.rootStore.notificationStore.error("There are no missing documents for this Facility.");
            }
        }
    }

    @action.bound
    async setShowOnlyPastTemplates() {
        this.showOnlyPastTemplates = !this.showOnlyPastTemplates;
    }
}

export default FacilityMissingDocsPreviewViewStore;
